import type { LegendItemProps } from './LegendItem.types';

export const LegendItem = ({
  item,
  color,
  label,
  value,
  unit,
  is_selected,
  handleClick,
  selected,
  grouping_key,
  chart_unit,
  tabIndex,
}: LegendItemProps): React.JSX.Element => {
  return (
    <button
      aria-pressed={is_selected}
      className={[
        'legend-item',
        is_selected === false ? 'is-not-selected' : '',
      ].filter(Boolean).join(' ')}
      onClick={(event) => handleClick?.(
        item,
        'legend',
        {
          selected,
          grouping_key,
          unit: chart_unit,
          event: event.nativeEvent,
        },
      )}
      tabIndex={tabIndex}
      type='button'
    >
      {color && (
        <div aria-hidden='true' data-area='color' style={{ backgroundColor: color }} />
      )}
      <span data-area='label'>{label}</span>
      {value !== undefined && (
        <span data-area='value'>({value}{unit ?? ''})</span>
      )}
    </button>
  );
};
